
import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Modal, Row, Select, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { IoAddOutline, IoArrowBack, IoLockClosed, IoPencil, IoReturnUpBackOutline, IoTrash, IoTrashOutline } from "react-icons/io5";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";

// COMPONENTS
import Table from '../../components/Table';

class UsuarioList extends React.Component {

    state = {
        _navigate: false,
        _loading: true,
        _map: false,
        _map_data: [],
        _params: window.location.href.split('/'),
        _type: this.props.type === 'list' ? 'Lista' : 'Lixeira',
        // TABLE
        table_load: true,
        table_column: [],
        table_data: [],
        table_search: '',
        table_pagination: {
            current: 1,
            total: 0,
            limit: 10
        },
        table_sorter: null,
        table_select: [],
        table_filter: { STATUS: '*', TYPE_CREDENTIAL_ID: '*' },
        filters: { STATUS: [], TYPE_CREDENTIAL_ID: [] }
    }

    back = (this.props.account) ? `/dashboard/cadastros/agencias/${this.state._params[6]}/usuarios` : "/dashboard/configuracoes/usuarios";
    back2 = (this.props.account) ? `/dashboard/cadastros/agencias` : "";

    componentDidMount = () => {
        titleWeb('Usuários')
        this.onFilters()
        this.onRenderColumns().then(() => this.onRenderData())
    }
    
    onFilters = () => {
        POST_API('/credential/filters.php', { token: getToken(), ACCOUNT_ID: (this.props.account) ? this.state._params[5] : '*' }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    // LOAD DATA
    onRenderData = () => {
        this.setState({table_load: true })
        var filter = this.state.table_filter;
        if (this.props.account) filter.ACCOUNT_ID = this.state._params[6]
        filter.TYPE = 'O'
        setTimeout(async () => {
            POST_API('/credential/search.php', { token: getToken(), pagination: JSON.stringify(this.state.table_pagination), filter: JSON.stringify(filter), sorter: JSON.stringify(this.state.table_sorter), search: this.state.table_search, type: this.props.type }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    this.setState({
                        table_data: res.data,
                        table_pagination: {
                            ...this.state.table_pagination,
                            total: res.summary.QTDE
                        }
                    })
                } else {
                    message.error({ content: res.msg, key: 'screen' })
                }
            }).catch(() => POST_CATCH()).finally(() => this.setState({table_load: false }))
        }, 500);
    }

    onAction = (ID, type, title) => {
        var self = this
        Modal.confirm({
            title: title,
            icon: <ExclamationCircleOutlined />,
            cancelText: 'Não',
            okText: 'Sim',
            onOk() {
                POST_API('/credential/del.php', { token: getToken(), ID: ID, type: type, selected: JSON.stringify(self.state.table_select) }).then(rs => rs.json()).then(res => {
                    if (res.return) {
                        message.success({ content: res.msg, key: 'screen' })
                        if (type === 'del-select' || type === 'rec-select') self.setState({table_select: []})
                        self.onRenderData()
                    } else {
                        message.warning({ content: res.msg, key: 'screen' })
                    }
                }).catch(() => {POST_CATCH()   }).finally(() => self.setState({_loading: false}))
            },
            onCancel() {},
        })
        
    }

    onRecover = (ID) => {
        var self = this
        Modal.confirm({
            title: 'Restaurar senha padrão?',
            icon: <ExclamationCircleOutlined />,
            cancelText: 'Não',
            okText: 'Sim',
            onOk() {
                POST_API('/credential/recpass.php', { token: getToken(), ID: ID }).then(rs => rs.json()).then(res => {
                    if (res.return) {
                        message.success({ content: res.msg, key: 'screen' })
                        self.onRenderData()
                    } else {
                        message.warning({ content: res.msg, key: 'screen' })
                    }
                }).catch(() => POST_CATCH()).finally(() => self.setState({_loading: false}))
            },
            onCancel() {},
        })
        
    }

    // FUNCTION TABLE
    onRenderColumns = async () => {
        
        this.setState({
            table_column: [
                { title: 'Nome', dataIndex: 'NAME', key: 'credential.NAME', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Tipo Usuário', dataIndex: 'TYPE_CREDENTIAL_NAME', width: 180, key: 'type_credential.NAME', align: 'center', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Ações', key: 'action', width: 100, render: (text, record) => (
                    <>
                    { this.props.type === 'list' ? (
                        <Row gutter={[4,4]} className="table__actions">
                            <Col><Button onClick={() => this.onRecover(record.ID)} className="table__btn table__btn_view" title='Redefinir Senha' type="primary" shape="circle" size="small"><IoLockClosed size={14} /></Button></Col>
                            <Col><Link to={record.ID}><Button className="table__btn table__btn_edit" title='Editar' type="primary" shape="circle" size="small"><IoPencil size={14} /></Button></Link></Col>
                            <Col><Button onClick={() => this.onAction(record.ID, 'del', 'Excluir registro?')} className="table__btn table__btn_delete" title='Excluir' type="primary" shape="circle" size="small"><IoTrash size={14} /></Button></Col>
                        </Row>
                    ) : (
                        <Row gutter={[4,4]} className="table__actions">
                            <Col><Button onClick={() => this.onAction(record.ID, 'rec', 'Recuperar registro?')} className="table__btn table__btn_recover" title='Recuperar' type="primary" shape="circle" size='small'><IoReturnUpBackOutline size={14} /></Button></Col>
                        </Row>
                    ) }
                    </>
                )},
            ]
        })
    }

    onTableChange = (pagination, filters, sorter, extra) => {
        this.setState({
            table_sorter: sorter
        })
        this.onRenderData()
    }

    onPaginationChange = (page, size) => {
        this.setState({
            table_pagination: {
                ...this.state.table_pagination,
                current: page,
                limit: size
            },
        })
        this.onRenderData()
    }

    onSearchChange = (e) => {
        this.setState({
            table_search: e.target.value
        })
        this.onRenderData()
    }

    onSelect = (selectedRowKeys, selectedRows) => {
        this.setState({table_select: selectedRows})
    };

    onChangePage = () => {
        console.log(this.props.type)
        this.setState({table_data: [], _type: this.props.type !== 'list' ? 'Lista' : 'Lixeira'})
        this.onRenderData()
    }

    render = () => {

        const routes = this.props.account ? [
            {title: <Typography className="page-bread">Cadastros</Typography>},
            {title: <Link to={this.back2}><Typography className="page-bread">Agências</Typography></Link>},
            {title: <Link to={this.back} onClick={this.onChangePage}><Typography className="page-bread">Usuários</Typography></Link>},
            {title: <Typography className="page-bread active">{this.state._type}</Typography>}
        ] : [
            {title: <Typography className="page-bread">Configurações</Typography>},
            {title: <Link to={this.back} onClick={this.onChangePage}><Typography className="page-bread">Usuários</Typography></Link>},
            {title: <Typography className="page-bread active">{this.state._type}</Typography>},
        ]
        
        if (this.state._navigate) {
            return (<Navigate to={'/painel'} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    { this.props.type === 'list' ? (
                        <>
                            <Link to="novo"><FloatButton className="float-button add" icon={<IoAddOutline color="#FFF" size={25} />}/></Link>
                            <Link to="lixeira"><FloatButton onClick={this.onChangePage} className="float-button trash" icon={<IoTrashOutline color="#FFF" size={25} />}/></Link>
                            { this.props.account ? <Link to={this.back2}><FloatButton onClick={this.onChangePage} className="float-button back2" icon={<IoArrowBack color="#FFF" size={25} />}/></Link> : null }
                        </>
                    ) : (
                        <Link to={this.back}><FloatButton onClick={this.onChangePage} className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                    )}
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        { this.props.type === 'list' ? (
                            <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                { this.state.table_select.length > 0 ? <Button onClick={() => this.onAction(null, 'del-select', 'Excluir registros?')} type="default" size="small" shape="round" className="sys-btn-default sys-btn-small"style={{marginRight: 5}}>Deletar Selecionados ({this.state.table_select.length})</Button> : null }
                                <Link to={'lixeira'}><Button onClick={this.onChangePage} type="default" size="small" shape="round" className="sys-btn-default sys-btn-small"style={{marginRight: 5}}>Lixeira</Button></Link>
                                <Link to={'novo'}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Novo</Button></Link>
                                { this.props.account ? <Link to={this.back2}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small" style={{marginLeft: 5}}>Voltar</Button></Link> : <Link to={'/dashboard/configuracoes'}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" style={{marginLeft: 5}} className="sys-btn-primary sys-btn-small">Voltar</Button></Link> }
                            </Col>
                        ) : (
                            <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                { this.state.table_select.length > 0 ? <Button onClick={() => this.onAction(null, 'rec-select', 'Recuperar registros?')} type="default" size="small" shape="round" className="sys-btn-default sys-btn-small"style={{marginRight: 5}}>Recuperar Selecionados ({this.state.table_select.length})</Button> : null }
                                <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                            </Col>
                        ) }
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={24} md={20}>
                            <Typography className="label_filter">Tipo Usuário</Typography>
                            <Select style={{width: '100%'}} value={this.state.table_filter.TYPE_CREDENTIAL_ID} onChange={(v) => this.setState({table_filter: { ...this.state.table_filter, TYPE_CREDENTIAL_ID: v }})}>
                                <Select.Option value="*">Todos</Select.Option>
                                { this.state.filters.TYPE_CREDENTIAL_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={4}>
                            <Button shape="round" block type="primary" onClick={this.onRenderData}>Filtrar</Button>
                        </Col>
                    </Row>
                    <Table
                        _onRecover={this.onRecover}
                        _onAction={this.onAction}
                        _columns={this.state.table_column}
                        _data={this.state.table_data}
                        _pagination={this.state.table_pagination}
                        _loading={this.state.table_load}
                        _onChangeTable={this.onTableChange}
                        _onChangePagination={this.onPaginationChange}
                        _onChangeSearch={this.onSearchChange}
                        _search={this.state.table_search}
                        _rowSelection={{onChange: this.onSelect, getCheckboxProps: () => {}}}
                    />
                </Col>
                
            </Row>
        )

    }

}

export default UsuarioList;